import { useEffect } from "react";

interface ImageLightboxProps {
  src: string | null;
  alt?: string;
  onClose: () => void;
}

export default function ImageLightbox({ src, alt = "", onClose }: ImageLightboxProps) {
  useEffect(() => {
    if (!src) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [src, onClose]);

  if (!src) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 md:p-10 animate-fade-in">
      <button
        type="button"
        aria-label="关闭图片预览"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/90 cursor-zoom-out"
      />
      <button
        type="button"
        onClick={onClose}
        aria-label="关闭"
        className="absolute top-4 right-4 md:top-6 md:right-6 w-10 h-10 rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 flex items-center justify-center transition-colors duration-200 cursor-pointer z-10"
      >
        <i className="ri-close-line text-xl" />
      </button>
      <div className="relative max-w-5xl w-full max-h-[85vh] flex items-center justify-center">
        <img
          src={src}
          alt={alt}
          className="max-h-[85vh] w-auto max-w-full object-contain rounded-lg"
        />
      </div>
      {alt && (
        <p className="absolute bottom-4 md:bottom-6 left-0 right-0 text-center text-xs md:text-sm text-background-200 px-6">
          {alt}
        </p>
      )}
    </div>
  );
}